import React from "react";
import IconError from "../../Icons/NotificationMessage/Error";
import IconInfo from "../../Icons/NotificationMessage/Info";
import IconSuccess from "../../Icons/NotificationMessage/Success";
import IconWarning from "../../Icons/NotificationMessage/Warning";
import { ENotificationType } from "../../Model/ENotificationType";
import "./InlineNotification.css";


type Props = {
  type: ENotificationType;
  message?: string;
  onClose: () => void;
  style?: React.CSSProperties;
};

const InlineNotification = ({
  type,
  message,
  onClose,
  style = {},
}: Props) => {
  let classMessage = "inline-notification";
  let iconMessage: React.ReactNode | null = null;
  switch (type) {
    case ENotificationType.Info:
      classMessage += " info";
      iconMessage = <IconInfo fill="#2F80ED" />;
      break;
    case ENotificationType.Warning:
      classMessage += " warning";
      iconMessage = <IconWarning />;
      break;
    case ENotificationType.Error:
      classMessage += " error";
      iconMessage = <IconError />;
      break;
    case ENotificationType.Success:
      classMessage += " success";
      iconMessage = <IconSuccess />;
      break;
  }

  return (
    <div className={classMessage} style={style}>
      <div className="inline-notification-icon">{iconMessage}</div>
      <div className="inline-notification-message">
        <span>{message}</span>
      </div>
      <div className="inline-notification-close" onClick={() => onClose()}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.3324 14L2 12.6676L6.66759 8.00004L2 3.33245L3.3324 2L8 6.6676L12.6676 2L14 3.3324C12.1412 5.20757 11.1912 6.12483 9.3324 8L14 12.6676L12.6676 14L8 9.3324L3.3324 14Z"
            fill="#313131"
          />
          <path
            d="M3.3324 14L2 12.6676L6.66759 8.00004L2 3.33245L3.3324 2L8 6.6676L12.6676 2L14 3.3324C12.1412 5.20757 11.1912 6.12483 9.3324 8L14 12.6676L12.6676 14L8 9.3324L3.3324 14Z"
            fill="#313131"
          />
        </svg>
      </div>
    </div>
  );
};

export default InlineNotification;
